/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { fromCamelCaseToNormal } from '../../utils/string';

const TypeDropdown = props => (
  <div className="dropdown btn-component-div">
    <button
      type="button"
      id="type-dropdown"
      className={`button-${props.type}`}
      data-toggle="dropdown"
      disabled={props.disabled}
      onClick={e =>
        props.toggleDropDownMenu(e, 'typeMenu', {
          handleSelect: props.handleSelect,
          options: props.options,
          field: props.type,
          index: props.rowIndex
        })
      }
    >
      {fromCamelCaseToNormal(props.data)}
    </button>
  </div>
);

TypeDropdown.propTypes = {
  handleSelect: PropTypes.func,
  type: PropTypes.string,
  data: PropTypes.string,
  options: PropTypes.object,
  disabled: PropTypes.bool
};

export default TypeDropdown;
